<script setup>

    import SoundButton from "./SoundButton.vue";

    let props = defineProps(["songs", "lang"]);
    let emits = defineEmits(["play", "stop"]);

    function openExternalLink (url)
    {
        window.open(url, "_blank");
    }

    function onPlay (callback, track)
    {
        emits("play", callback, track);
    }

    function onStop ()
    {
        emits("stop");
    }
</script>

<template>
    <div class="scrollable">
        <ul class="songs-list">
            <li v-for="song in songs">
                <SoundButton
                    :id="n"
                    :file="song.audio.url"
                    @play="onPlay"
                    @stop="onStop"
                />
                <div>
                    <p class="song-author">{{ song.composer }}</p>
                    <h2 class="song-title">{{ song.name[lang] }}</h2>
                </div>
                <button class="btn-icon btn-external" @click="() => openExternalLink(song.url)">
                    <svg viewBox="0 0 32 31"><path fill="currentColor" d="M.308235 20.1517c-.629362.8717-.3318595 2.4365 2.239935 4.7562 2.5718 2.3196 4.11505 4.8001 5.04765 5.4139.93686.6102 1.79104 1.1506 5.64988-4.0096 3.8589-5.1602 6.6698-9.4511 6.6698-9.4511s3.6449 6.8876 4.9829 7.9615c1.338 1.0738 2.7307.8955 4.7046-5.2745 1.9696-6.1663 2.8039-17.58301.4707-18.40587C26.8581.00426011 22.5347.122062 12.9883.994435 8.47224 1.40536 5.96521 3.15007 8.92317 5.86454c2.95793 2.71447 5.54173 4.70396 5.54173 4.70396S2.30244 17.3929.31617 20.1523l-.007935-.0006Z" /></svg>
                    <span class="sr-only">Ouvrir le lien</span>
                </button>
            </li>
        </ul>
    </div>
</template>

<style scoped>

</style>
